import { useState } from 'react'

import { previewModes } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'
import {
  loadStoredEditorValue,
  saveStoredEditorValue,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

import { previewModeStorageKeyPrefix } from './constants'

const usePreviewSettings = ({ storeId }) => {
  const [previewMode, setPreviewMode] = useState(() => {
    return loadStoredEditorValue(previewModeStorageKeyPrefix, storeId) ?? previewModes.customScenario
  })
  const [showHiddenBlocks, setShowHiddenBlocks] = useState(true)
  const [showPreviewSettings, setShowPreviewSettings] = useState(false)

  const openPreviewSettings = () => setShowPreviewSettings(true)

  const closePreviewSettings = () => setShowPreviewSettings(false)

  const selectPreviewMode = mode => {
    saveStoredEditorValue(previewModeStorageKeyPrefix, storeId, mode)
    setPreviewMode(mode)
  }

  const changeShowHiddenBlocks = value => setShowHiddenBlocks(value)

  return {
    previewMode,
    selectPreviewMode,
    showHiddenBlocks,
    changeShowHiddenBlocks,
    showPreviewSettings,
    openPreviewSettings,
    closePreviewSettings,
  }
}

export default usePreviewSettings
